import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Divider, Stack } from '@mui/material';
import { EmailVerifyStep } from './EmailVerifyStep';
import { AppVerifyStep } from './AppVerifyStep';

interface TwoFactorVerifyStepProps {
    method: string;
    target: string;
    next: CallableFunction;
    back: CallableFunction | null;
    notify: CallableFunction;
    verify: CallableFunction;
    qrCode: string | null;
    isFirstTime?: boolean;
}

export default function TwoFactorVerifyStep({
    method,
    target,
    next,
    back,
    notify,
    verify,
    qrCode,
    isFirstTime = false,
}: TwoFactorVerifyStepProps) {
    const [code, setCode] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const __ = (window as any).__
        ? ((window as any).__ as (text: string, ...args: Array<string | number>) => string)
        : (text: string, ...args: Array<string | number>) => text;

    const process = () => {
        verify(code)
            .then((response: any) => {
                if (response.data.status == 'ok') {
                    next();
                }
            })
            .catch((error: any) => {
                setShowAlert(true);
                if (error?.response?.status === 429) {
                    setAlertText(__('Zbyt wiele prób. Spróbuj ponownie później.'));
                } else if (error?.response?.data?.status === 'expired') {
                    setAlertText(__('Kod wygasł. Wyślij nowy kod.'));
                } else {
                    setAlertText(__('Nieprawidłowy kod'));
                }

                setTimeout(() => {
                    setShowAlert(false);
                }, 10000);
            });
    };

    useEffect(() => {
        notify();
    }, [notify]);

    return (
        <Box>
            {showAlert && (
                <Alert sx={{ my: 2 }} severity="error">
                    {alertText}
                </Alert>
            )}
            {method === 'EMAIL' && <EmailVerifyStep target={target} setCode={setCode} notify={notify} />}
            {method === 'APP' && <AppVerifyStep qrCode={qrCode} setCode={setCode} isFirstTime={!!isFirstTime} />}
            <Divider sx={{ my: 2 }} />
            <Stack spacing={2} direction="row" justifyContent="center">
                <Button onClick={() => process()} variant="contained">
                    {__('Zweryfikuj kod')}
                </Button>
                {back && (
                    <Button onClick={() => back()} variant="outlined">
                        {__('Wstecz')}
                    </Button>
                )}
            </Stack>
        </Box>
    );
}
